module.exports = __webpack_public_path__ + "img/2.76910503.png";